import React, { useState, forwardRef, useImperativeHandle, useEffect, useRef } from "react";
import { IconPlus } from '@tabler/icons-react'
import StepperNavigationButtons from "../../../MyInvitations/Common/StepperNavigationButtons";
import ServiceItem from "./ServiceItem";

const Services = forwardRef(
  function Services(props, ref) {
    const [services, setServices] = useState([]);
    useEffect(() => {
      if (props.data) {
        setServicesData(props.data);
      }
    }, [props.data]);

    const setServicesData = (data) => {
      let servicesData = [];
      data.forEach((item, index) => {
        servicesData.push({
          id: item.id ?? Math.floor((Math.random() * 10000) + 1),
          title: item.title,
          description: item.description,
          serviceLink: item.serviceLink ?? '',
          show: index == 0,
          isValid: false,
          ref: null
        })
      });

      setServices(servicesData);
    }

    const handleAddService = () => {
      let service =
      {
        id: Math.floor((Math.random() * 10000) + 1),
        title: "Service " + (services.length + 1),
        serviceLink: '',
        description:'',
        show: true,
        isValid: false,
        ref: null
      }

      setServices(currentServices => {
        currentServices.forEach((service) => {
          service["show"] = false;
        });
        let newServices = [...currentServices, service];
        return newServices
      });
    }

    const showHideService = (index) => {
      const currentServices = [...services];

      currentServices.forEach((service, innerIndex) => {
        if (index == innerIndex)
          service["show"] = !service["show"];
        else
          service["show"] = false;
      });

      setServices(currentServices);
    }

    const deleteServiceHandler = (targetIndex) => {
      const filteredServices = services.filter((item, index) => index !== targetIndex);

      if (filteredServices.length == 1 || targetIndex == 0 && filteredServices.length > 0) {
        filteredServices[0]["show"] = true;
      }
      else {
        filteredServices.forEach((service, index) => {
          if (index == targetIndex - 1)
            service["show"] = true;
        });
      }
      setServices(filteredServices);
    }

    const validate = () => {
      let isValid = true;
      const currentServices = [...services];
      currentServices.forEach(service => {
        let validationStatus = service.ref?.validate() ?? false;
        service["isValid"] = validationStatus;

        if (!validationStatus) {
          isValid = false;
        }
      });
      setServices(currentServices);
      return isValid;
    }

    const getData = () => {
      let servicesData = [];

      services.forEach(service => {
        let data = service.ref?.getData() ?? null;
        if (data)
          servicesData.push(data);
      });

      return servicesData;
    }

    useImperativeHandle(ref, () => ({
      getData: getData,
      validate: validate
    }));

    return (
      <div className="content d-block visible">
        <div className="content-header mb-3 d-flex justify-content-between">
          <div className="sec-titler">
            <h2 className="text-primary">Services</h2>
            <div className="title-shape"></div>
            <small className="fs-11 mb-0"></small>
          </div>
          <div className="mb-0 text-right">
            <button className="btn btn-primary align-middle" onClick={handleAddService}>
              <IconPlus className="me-sm-1 me-0" size={20} />
              Add Service
            </button>
          </div>
        </div>
        <form>
          <div className="row g-3">
            <div className="accordion mt-3">
              {
                (!services || (services && services.length == 0)) && (
                  <div className="row justify-content-center">
                    <div className="col-md-5 col-lg-4 col-11">
                      <div className="d-flex flex-column align-items-center">
                        <img src="/images/nodata.svg" />
                        <div className="helper-message">
                          No Services information<br /> Get started by creating
                        </div>
                        <button type="button" className="mt-2 btn btn-primary btn btn-secondary" onClick={handleAddService}>
                          <IconPlus className="me-sm-1 me-0" size={20} />
                          Add Services
                        </button>
                      </div>
                    </div>
                  </div>
                )
              }

              {services && services.length > 0 &&
                services.map((service, index) => {
                  return (
                    <ServiceItem
                      data={service}
                      index={index}
                      showHideService={showHideService}
                      deleteService={deleteServiceHandler}
                      key={service.id}
                      ref={el => service.ref = el}
                      showDelete={true} />
                  )
                })
              }
            </div>

            <StepperNavigationButtons index={props.index} steps={props.steps} navigate={props.navigate} />
          </div>
        </form>
      </div>
    )
  });

export default Services;
